module.exports = __webpack_public_path__ + "static/media/youre_in_control.e076b4db.png";